<div
  class="input-validation-wrap"
  [class.with-second-icon]="config?.inputWithSecondIcon"
>
  <ng-content></ng-content>
</div>
<ng-content select=".invalid-feedback" *ngIf="isInvalid"></ng-content>
